module.exports = __webpack_public_path__ + "img/UTCORA-4.7c2bb2ee.jpg";